module.exports = __webpack_public_path__ + "static/img/fenghuangshan.a3b6b63.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/example/fenghuangshan.jpg
// module id = ZedS
// module chunks = 1